import type { AxiosInstance } from 'axios';
import type { TranslateFn, U2000ApiErrorResult } from '../u2000Core/axios/U2000HandleApiError';
import { doFetchKpiInitLU } from '../u340xKpiShared/api/u340xKpiStandaloneApi';
import type { U340xKpiStandaloneInitLU } from '../u340xKpiShared/types/u340xKpiLuTypes';

export const U3403_LU_CODE = 'U3403' as const;

export type U3403InitLU = U340xKpiStandaloneInitLU;

export const doInitLU = (axios: AxiosInstance) => {
  return doFetchKpiInitLU(axios, U3403_LU_CODE);
};

export function luHandleAppiError(
  t: TranslateFn,
  nameSpace: string,
  err: unknown,
  errorResult: U2000ApiErrorResult,
) {
  void err;
  if (!errorResult.genericErrors?.length) {
    errorResult.genericErrors = [
      {
        title: t('errorTitle', { ns: nameSpace }),
        text: t('errGeneric', { ns: nameSpace }),
      },
    ];
  }
  return errorResult;
}
